"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Constants = require("../00_environment/Constants");

var _Fonts = require("../00_environment/Fonts");

var _Page = _interopRequireDefault(require("../01_atoms/Page"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _LinkButton = _interopRequireDefault(require("../01_atoms/LinkButton"));

var _logo = _interopRequireDefault(require("../../assets/logo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var WelcomePageUI = function WelcomePageUI(_ref) {
  var translatorForNamespace = _ref.translatorForNamespace,
      connectLink = _ref.connectLink,
      registerLink = _ref.registerLink,
      bookLink = _ref.bookLink;
  var t = translatorForNamespace('WelcomePageUI');
  return /*#__PURE__*/_react["default"].createElement(_Page["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: _logo["default"],
    size: "small",
    verticalAlign: "middle"
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    style: (0, _Fonts.withBoldTitleFont)({})
  }, t('Welcome to {appName}', {
    appName: _Constants.appName
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withDefaultFont)({
      textAlign: 'center'
    })
  }, t("Let's redefine travel together"))), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: '5%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: bookLink,
    primary: true,
    fluid: true,
    style: {
      marginRight: '2.5%'
    }
  }, t('Book a trip')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: connectLink,
    fluid: true,
    style: {
      marginLeft: '2.5%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, t('Log in'))), /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_LinkButton["default"], {
    to: registerLink
  }, t('Create an account')))));
};

var _default = WelcomePageUI;
exports["default"] = _default;